/**
 * Private modules
 */
const {
  createQueryComponent,
  systemId,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  getSystemGames: {
    properties: {
      params: {
        properties: {
          systemId,
        },
        required: ['systemId'],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: ['params'],
    type: 'object',
  },
};
